// extracted by mini-css-extract-plugin
module.exports = {"paymentOptions":"d3hEogn","provider":"_2t5mfE3"};